module.exports = __webpack_public_path__ + "img/addition_template.5e3391c6.png";